<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <!-- <div>{{ filter }}</div> -->
    <!-- <div>{{ filterApplied }}</div> -->
    <!-- <div>Vehicle: {{vehiclesServiceOrders}}</div> -->
    <b-row>
      <b-col>
        <div class="right">
          <b-button size="sm" @click="openModal">
            {{ $t("geral.filtersAdvanced") }}
          </b-button>
        </div>
        <kanban-filter ref="kanbanFilter" @filter-confirm="applyFilter">
        </kanban-filter>
      </b-col>
    </b-row>
    <kanban-board id="kanban-board" :towers="towersFiltred">
      <template v-slot:card="{ item }">
        <div v-if="item.url">
          <cargo-kanban-card-cargo :item="item" @refreshData="refreshKanban">
          </cargo-kanban-card-cargo>
        </div>
        <div v-else>
          <cargo-kanban-card-fixed :item="item" @refreshData="refreshKanban">
          </cargo-kanban-card-fixed>
        </div>
      </template>
      <template v-slot:tower-footer="{ amount, tower }">
        <div v-if="tower.name == 'Motoristas disponíveis'">
          <div v-if="amount === 1">{{ amount }} motorista</div>
          <div v-else>{{ amount }} motoristas</div>
        </div>
        <div v-else-if="tower.name == 'Veículos com OS'">
          <div v-if="amount === 1">{{ amount }} veículo</div>
          <div v-else>{{ amount }} veículos</div>
        </div>
        <div v-else>
          <div v-if="amount === 1">{{ amount }} carga</div>
          <div v-else>{{ amount }} cargas</div>
        </div>
      </template>
    </kanban-board>
    <!-- <div>ModelData: {{towers.cards}}</div> -->
  </div>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import KanbanBoard from "@/components_rms/kanban_slot/KanbanBoardSlot.vue";
import KanbanFilter from "@/components_rms/tracking/cargo/kanbanFilter/KanbanFilter.vue";
import CargoKanbanCardCargo from "@/pagesRms/tracking/cargo/CargoKanbanCardCargo.vue";
import CargoKanbanCardFixed from "@/pagesRms/tracking/cargo/CargoKanbanCardFixed.vue";
import { format, functor } from "d3";
import { formatDate } from "@fullcalendar/core";

export default {
  name: "CargoKanban",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    KanbanBoard,
    KanbanFilter,
    CargoKanbanCardCargo,
    CargoKanbanCardFixed,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      drivers: [],
      vehiclesServiceOrders: [],
      filterApplied: {
        client: [],
        branchName: [],
        dateDeliveryForecast: [],
        dateAttendanceExpiration: [],
        origin: [],
        destination: [],
        vehiclePlate: [],
        driver: [],
        dateAttendance: [],
      },
      lastSync: null,
      selectedTags: [],
      towers: [],
      towersFiltred: [],
      permissions: 0,
    };
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  },
  created() {
    this.init();
    // this.getPermision();
  },
  computed: {
    getUrlPermission() {
      return `v1/getOccurrencePermissions/${this.id}`;
    },
  },
  methods: {
    getDateTimeNow() {
      var dateOffset = 60 * 60 * 1000 * 3; //3 hours
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      return myDate;
    },
    refreshKanban() {
      this.fetchEventsList();
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    async fetchEventsList() {
      if (this.towers.length == 0) {
        this.loadTowerStart();
      } else {
        let newCargos = await this.getNewCargos();
        this.removeExistingCargos(newCargos);
        this.addNewCargos(newCargos);
        this.refreshCargosElapsedTime();
        await this.loadVehiclesServiceOrders();
        this.loadTowerVehicleServiceOrders(this.towers);
        this.loadTowerDrivers(this.towers);
        this.filterTowers();
      }
    },
    filterCards(tower, filters, propertyCompare, filterToAply) {
      if (tower.sequenceNumber == 0) return;

      if (filters[filterToAply]) {
        if (filters[filterToAply].length > 0) {
          tower.cards = tower.cards.filter((card) => {
            let tudocerto = false;
            filters[filterToAply].forEach((f) => {
              if (!card[propertyCompare]) return;
              if (!f) return;
              if (
                card[propertyCompare].toLowerCase().includes(f.toLowerCase())
              ) {
                tudocerto = true;
              }
            });
            return tudocerto;
          });
        }
      }
    },
    filterTowers() {
      if (!this.towers) return [];
      const filtredTowers = JSON.parse(JSON.stringify(this.towers));
      filtredTowers.forEach((t) => {
        this.filterCards(t, this.filterApplied, "clientName", "client");
        this.filterCards(t, this.filterApplied, "branchName", "branchName");
        this.filterCards(
          t,
          this.filterApplied,
          "dateDeliveryForecast",
          "dateDeliveryForecast"
        );
        this.filterCards(
          t,
          this.filterApplied,
          "dateAttendanceExpiration",
          "dateAttendanceExpiration"
        );
        this.filterCards(t, this.filterApplied, "destination", "destination");
        this.filterCards(t, this.filterApplied, "origin", "origin");
        this.filterCards(t, this.filterApplied, "vehiclePlate", "vehiclePlate");
        this.filterCards(t, this.filterApplied, "driverName", "driver");
        this.filterCards(
          t,
          this.filterApplied,
          "dateAttendance",
          "dateAttendance"
        );
        t.cards = t.cards.sort(function (a, b) {
          if (a.willExpire === b.willExpire) {
            return a.id > b.id ? 1 : -1;
          }
          return a.willExpire < b.willExpire ? 1 : -1;
        });
      });
      this.towersFiltred = filtredTowers;
      this.$forceUpdate();
    },
    applyFilter(filter) {
      this.filterApplied.client = Array.from(filter.client);
      this.filterApplied.branchName = Array.from(filter.branchName);
      this.filterApplied.dateDeliveryForecast = Array.from(
        filter.dateDeliveryForecast
      );
      this.filterApplied.dateAttendanceExpiration = Array.from(
        filter.dateAttendanceExpiration
      );
      this.filterApplied.origin = Array.from(filter.origin);
      this.filterApplied.destination = Array.from(filter.destination);
      this.filterApplied.vehiclePlate = Array.from(filter.vehiclePlate);
      this.filterApplied.driver = Array.from(filter.driver);
      this.filterApplied.dateAttendance = Array.from(filter.dateAttendance);
      this.filterTowers(this.towers);
    },
    openModal() {
      this.$refs.kanbanFilter.modalOpen();
    },
    async init() {
      await this.loadDrivers();
      await this.loadVehiclesServiceOrders();
      await this.fetchEventsList();
      this.timer = setInterval(
        this.fetchEventsList,
        this.$store.getters.autoRefreshTime
      );
    },
    async loadDrivers() {
      this.drivers = [];
      await this.$api
        .get("/v1/cargo/driver/all")
        .then((response) => {
          this.drivers = response.data;
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    async loadVehiclesServiceOrders() {
      this.vehiclesServiceOrders = [];
      await this.$api
        .get("v1/cargo/vehicle/serviceOrders")
        .then((response) => {
          this.vehiclesServiceOrders = response.data;
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    // loadCteAccessKey(cargoId) {
    //   this.$api
    //     .post("/generate/GWGetCteAccessKey/" + cargoId)
    //     .then((reponse) => {});
    // },
    async loadTowerStart() {
      this.lastSync = this.getDateTimeNow();
      this.$api
        .get("/v2/cargo/kanban/")
        .then((response) => {
          let model = response.data;
          if (model != null) {
            model.forEach((tower) => {
              tower.cards.forEach((card) => {
                card.url = `/trackingShippingCompany/cargo/kanbanEdit/${card.id}`;
                card.text = this.getText(card);
                if (tower.name != "Checklist de carregamento") {
                  if (card.checklistId) {
                    card.url2 = `/trackingShippingCompany/checklist/filled/details/${card.checklistId}`;
                  }
                }
              });
            });
            this.loadTowerVehicleServiceOrders(model);
            this.loadTowerDrivers(model);
            this.towers = model;
            this.filterTowers();
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    async getNewCargos() {
      let dateSearch = this.lastSync;
      this.lastSync = this.getDateTimeNow();
      let towers = [];
      await this.$api
        .get("/v1/cargo/lastDate/" + dateSearch.toJSON())
        .then((response) => {
          console.log(response);
          towers = response.data;
        });
      return towers;
    },
    getElapsedTime(startTime) {
      // later record end time
      var endTime = new Date();

      // time difference in ms
      var timeDiff = endTime - startTime;

      // strip the miliseconds
      timeDiff /= 1000;

      // get seconds
      var seconds = Math.round(timeDiff % 60);

      // remove seconds from the date
      timeDiff = Math.floor(timeDiff / 60);

      // get minutes
      var minutes = Math.round(timeDiff % 60);
      var minutesStr = minutes.toString().padStart(2, "0");

      // remove minutes from the date
      timeDiff = Math.floor(timeDiff / 60);

      // get hours
      var hours = Math.round(timeDiff % 24);
      var hoursStr = hours.toString().padStart(2, "0");

      // remove hours from the date
      timeDiff = Math.floor(timeDiff / 24);

      // the rest of timeDiff is number of days
      var days = timeDiff;
      var daysStr = timeDiff.toString().padStart(2, "0");

      var texto = "";
      if (days > 0) {
        texto = daysStr + "d " + hoursStr + "h " + minutesStr + "m";
      } else if (hours == 0 && minutes == 0) {
        texto = "00h 01m";
      } else {
        texto = hoursStr + "h " + minutesStr + "m";
      }
      return texto;
    },
    refreshCargosElapsedTime() {
      this.towers.forEach((tower) => {
        if (
          tower.name != "Motoristas disponíveis" &&
          tower.name != "Veículos com OS"
        ) {
          tower.cards.forEach((card) => {
            card.elapsedTime = this.getElapsedTime(
              new Date(card.lastOccurrenceDate)
            );
          });
        }
      });
    },
    removeExistingCargos(newCargos) {
      this.towers.forEach((tower) => {
        for (let i = tower.cards.length - 1; i >= 0; i--) {
          let cargoCard = tower.cards[i];
          newCargos.forEach((newCargo) => {
            if (newCargo.id == cargoCard.id) {
              tower.cards.splice(i, 1);
            }
          });
        }
      });
    },
    addNewCargos(newCargos) {
      this.towers.forEach((tower) => {
        newCargos.forEach((newCargo) => {
          if (tower.name == newCargo.lastStatusDescription) {
            newCargo.url = `/trackingShippingCompany/cargo/kanbanEdit/${newCargo.id}`;
            newCargo.text = this.getText(newCargo);
            if (tower.name != "Checklist de carregamento") {
              if (newCargo.checklistId) {
                newCargo.url2 = `/trackingShippingCompany/checklist/filled/details/${newCargo.checklistId}`;
              }
            }
            tower.cards.push(newCargo);
          }
        });
      });
    },
    loadTowerDrivers(towers) {
      if (this.drivers == null) return;
      let driversTower = null;
      towers.forEach((tower) => {
        if (tower.name == "Motoristas disponíveis") {
          driversTower = tower;
        }
      });
      if (!driversTower) {
        driversTower = {
          name: "Motoristas disponíveis",
          sequenceNumber: 0,
          cards: [],
        };
        towers.unshift(driversTower);
      }
      let driversCard = [];
      this.drivers.forEach((driver) => {
        if (this.isDriverAvailable(towers, driver) == true) {
          let typeSequence = 1;
          if (driver.driverType == "a") typeSequence = 2;
          driversCard.push(this.getDriverCard(driver));
        }
      });
      driversCard = driversCard.sort(function (a, b) {
        if (a.typeSequence === b.typeSequence) {
          return a.driverName.localeCompare(b.driverName);
        }
        return a.typeSequence > b.typeSequence ? 1 : -1;
      });
      driversTower.cards = driversCard;
      return driversTower;
    },
    loadTowerVehicleServiceOrders(towers) {
      if (this.vehiclesServiceOrders == null) return;
      let vehicleServiceOrdersTower = null;
      towers.forEach((tower) => {
        if (tower.name == "Veículos com OS") {
          vehicleServiceOrdersTower = tower;
        }
      });
      if (!vehicleServiceOrdersTower) {
        vehicleServiceOrdersTower = {
          name: "Veículos com OS",
          sequenceNumber: 1,
          cards: [],
        };
        towers.unshift(vehicleServiceOrdersTower);
      }
      let vehicleServiceOrderssCard = [];
      this.vehiclesServiceOrders.forEach((vehicle) => {
        vehicleServiceOrderssCard.push(
          this.getVehicleServiceOrderCard(vehicle)
        ); // vehicle
      });
      vehicleServiceOrderssCard = vehicleServiceOrderssCard.sort(function (
        a,
        b
      ) {
        return a.vehiclePlate.localeCompare(b.vehiclePlate);
      });
      vehicleServiceOrdersTower.cards = vehicleServiceOrderssCard;
      return vehicleServiceOrdersTower;
    },
    getDriverCard(driver) {
      let typeSequence = 1;
      if (driver.driverType == "a") typeSequence = 2;
      return {
        driverName: driver.name,
        driverPersonalDocument: driver.document,
        vehiclePlate: driver.plateMain,
        branchName: "",
        cargoTypeId: 0,
        checklistId: null,
        clientName: "",
        companyId: "",
        dateAttendance: null,
        dateAttendanceExpiration: null,
        dateDeliveryForecast: "",
        destination: "",
        destinationCityName: "",
        destinationStateAbrev: "",
        elapsedTime: "",
        id: 0,
        lastOccurrenceDate: "",
        lastStatusDescription: "",
        lastStatusId: 1,
        origin: "",
        originCityName: "",
        originStateAbrev: "",
        text: this.getTextDriver(driver),
        typeSequence: typeSequence,
        url: null,
      };
    },
    getVehicleServiceOrderCard(vehicle) {
      return {
        driverName: "",
        driverPersonalDocument: "",
        vehiclePlate: vehicle.plate,
        branchName: "",
        cargoTypeId: 0,
        checklistId: null,
        clientName: "",
        companyId: "",
        dateAttendance: null,
        dateAttendanceExpiration: null,
        dateDeliveryForecast: "",
        destination: "",
        destinationCityName: "",
        destinationStateAbrev: "",
        elapsedTime: "",
        id: 0,
        lastOccurrenceDate: "",
        lastStatusDescription: "",
        lastStatusId: 1,
        origin: "",
        originCityName: "",
        originStateAbrev: "",
        text: this.getTextVehicleServiceOrders(vehicle),
        typeSequence: 1,
        url: null,
      };
    },
    getText(card) {
      if (card.cargoPath != null) {
        card.destination = `${card.cargoPath.destinationCityName} - ${card.cargoPath.destinationStateAbrev}`;
        card.origin = `${card.cargoPath.originCityName} - ${card.cargoPath.originStateAbrev}`;
      } else {
        card.destination = `${card.destinationCityName} - ${card.destinationStateAbrev}`;
        card.origin = `${card.originCityName} - ${card.originStateAbrev}`;
      }

      let isOpened =
        card.lastStatusId == 1 ||
        card.lastStatusId == 2 ||
        card.lastStatusId == 13;

      let cargoTypeDescription;

      if (card.cargoTypeId == 2) cargoTypeDescription = "Subcontrato";
      else cargoTypeDescription = "Contrato";

      let text = `Tipo: ${cargoTypeDescription}`;

      if (card.lastStatusId == 3) {
        if (card.status == null) text += `\nStatus do checklist:`;
        else text += `\nStatus do checklist: ${card.status}`;
      }

      text += `\nCliente: ${card.clientName}`;

      if (card.branchName == null) {
        text += `\nFilial:`;
      } else {
        text += `\nFilial: ${card.branchName}`;
      }

      if (this.hourToString(card.dateDeliveryForecast) == "00:00") {
        text += `\nEntrega desejada: ${this.dateToString(
          card.dateDeliveryForecast
        )}`;
      } else {
        text += `\nEntrega desejada: ${this.dateToString(
          card.dateDeliveryForecast
        )} - ${this.hourToString(card.dateDeliveryForecast)}`;
      }

      if (isOpened || card.lastStatusId == 12) {
        if (card.dateAttendanceExpiration == null) {
          text += `\nExpiração:`;
        } else {
          text += `\nExpiração: ${this.dateToString(
            card.dateAttendanceExpiration
          )}`;
        }
      }
      text += `\nOrigem: ${card.origin}`;
      text += `\nDestino: ${card.destination}`;

      if (!isOpened && card.lastStatusId != 12) {
        if (card.vehiclePlate == null) {
          text += `\nPlaca: `;
        } else {
          text += `\nPlaca: ${card.vehiclePlate}`;
        }
        if (card.driverName == null) {
          text += `\nMotorista: `;
        } else {
          text += `\nMotorista: ${card.driverName}`;
        }
        if (card.driverPersonalDocument == null) {
          text += `\nCPF: `;
        } else {
          text += `\nCPF: ${card.driverPersonalDocument}`;
        }
      }
      if (isOpened || card.lastStatusId == 12) {
        if (card.dateAttendance == null) {
          text += `\nAtendimento/coleta:`;
        } else if (this.hourToString(card.dateAttendance) == "00:00") {
          text += `\nAtendimento/coleta: ${this.dateToString(
            card.dateAttendance
          )}`;
        } else {
          text += `\nAtendimento/coleta: ${this.dateToString(
            card.dateAttendance
          )} - ${this.hourToString(card.dateAttendance)}`;
        }
      }
      if (card.pathSequenceNumber != null) {
        text += `\n\nTrajeto em andamento: ${card.pathSequenceNumber}`;
        text += `\n${card.pathDestinationCityName} - ${card.pathDestinationStateAbrev}`;
        text += `\n${card.pathOriginCityName} - ${card.pathOriginStateAbrev}`;
      }
      return text;
    },
    getTextDriver(card) {
      let driverType;
      if (card.driverType == "a") driverType = "Agregado";
      else driverType = "Funcionário";
      let text = `Tipo: ${driverType}`;
      text += `\nMotorista: ${card.name}`;
      text += `\nCPF: ${card.document}`;
      text += `\nPlaca: ${card.plateMain}`;
      return text;
    },
    getTextVehicleServiceOrders(vehicle) {
      let text = `Placa: ${vehicle.plate}`;
      let serviceOrders = [];
      for (let serviceOrder of vehicle.serviceOrders) {
        serviceOrders.push(serviceOrder.number);
      }
      text += `\nOS's: ${serviceOrders.join(", ")}`;
      let cardsThePlateIs = this.inWhatCardsThePlateIs(
        this.towers,
        vehicle.plate
      );
      let cardsThePlateIsIds = [];
      for (let card of cardsThePlateIs) {
        cardsThePlateIsIds.push(`#${card.id}`);
      }
      if (cardsThePlateIsIds.length > 0) {
        text += `\nCarga: ${cardsThePlateIsIds.join(", ")}`;
      }
      return text;
    },
    hourToString(value) {
      let hour = new Date(value);

      if (hour.getHours() < 10 && hour.getMinutes() < 10)
        return "0" + hour.getHours() + ":0" + hour.getMinutes("MM");
      else if (hour.getHours() < 10)
        return "0" + hour.getHours() + ":" + hour.getMinutes();
      else if (hour.getMinutes() < 10)
        return hour.getHours() + ":0" + hour.getMinutes();
      else return hour.getHours() + ":" + hour.getMinutes();
    },
    dateToString(value) {
      if (value.indexOf("T") > 0) {
        value = value.substring(0, value.indexOf("T"));
      }
      let date = new Date(`${value} 00:00:00`);
      return date.toLocaleDateString();
    },
    isDriverAvailable(towers, driver) {
      for (let tower of towers) {
        if (
          tower.name != "Motoristas disponíveis" &&
          tower.name != "Veículos com OS"
        ) {
          for (let card of tower.cards) {
            if (card.driverPersonalDocument == driver.document) {
              if (card.lastStatusId != 11 && card.lastStatusId != 12) {
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    getPermision() {
      this.$api
        .get(this.getUrlPermission)
        .then((response) => {
          this.permissions = response.data.permissions;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    inWhatCardsThePlateIs(towers, vehiclePlate) {
      let cards = [];
      for (let tower of towers) {
        if (
          tower.name != "Motoristas disponíveis" &&
          tower.name != "Veículos com OS"
        ) {
          for (let card of tower.cards) {
            if (card.vehiclePlate == vehiclePlate) {
              if (card.lastStatusId != 11 && card.lastStatusId != 12) {
                cards.push(card);
              }
            }
          }
        }
      }
      return cards;
    },
    // getCteKey(cargo) {
    //   this.$api
    //     .post("/generate/GWGetCteAccessKey/" + cargo.id)
    //     .then((response) => {})
    //     .catch((error) => {
    //       if (error.response.status == 401) {
    //         this.$store.dispatch("logout").then(() => {
    //           this.$router.push("/login");
    //         });
    //       } else {
    //         this.alert.error = error.message;
    //         this.$refs.danger.show();
    //       }
    //     });
    // },
  },
};
</script>

<style scoped>
#kanban-board {
  height: calc(100vh - 137px);
}

.btn-tag {
  font-size: 0.875rem;
}
.form-control-tag {
  border: none;
}
.right {
  text-align: right;
  width: 100%;
}
.kanban-modal {
  z-index: 1060;
}
.search-icon {
  background: #2c3b5d;
  width: 3rem;
  height: 100%;
  padding-top: 8px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
</style>